import { SubjectDesign } from '../shared/SubjectContent.types';

// Figma 최종 분리파일 및 2026-10-23 검수 반영. 좌표는 GNB 125px을 제외한 본문 기준.
export const finalDesign: SubjectDesign = {
    height: 6959,
    backgrounds: [
        {
            top: 1128,
            height: 655,
            color: '#ffffff',
        },
        {
            top: 810,
            height: 318,
            color: '#b126f6',
        },
        {
            top: 1783,
            height: 880,
            file: 'backdrop-1908.png',
        },
        {
            top: 2666,
            height: 1147,
            color: '#ffffff',
        },
        {
            top: 3810,
            height: 823,
            color: '#fff0fe',
        },
        {
            top: 4636,
            height: 1136,
            color: '#ffffff',
        },
        {
            top: 5772,
            height: 687,
            color: '#eff5ff',
        },
        {
            top: 6459,
            height: 500,
            file: 'backdrop-6584.png',
        },
    ],
    artworks: [
        {
            top: 0,
            left: -650,
            width: 2560,
            height: 810,
            file: 'section-0.webp',
            alt: '윙크 배경지식을 학습하는 아이들',
        },
        {
            top: 1128,
            left: 0,
            width: 1260,
            height: 655,
            file: 'section-1.webp',
            alt: '재미 중심 콘텐츠와 윙크 배경지식 비교',
        },
        {
            top: 1783,
            left: 0,
            width: 1260,
            height: 880,
            file: 'section-2.webp',
            alt: '세상의 다양한 지식을 배우는 윙크 배경지식',
        },
        {
            top: 3810,
            left: 0,
            width: 1260,
            height: 823,
            file: 'section-4.webp',
            alt: '초등 교과와 학교생활 학습 예시',
        },
        {
            top: 4636,
            left: 0,
            width: 1260,
            height: 1136,
            file: 'section-5.webp',
            alt: '한자 워크북과 모의고사',
        },
        {
            top: 5772,
            left: 0,
            width: 1260,
            height: 687,
            file: 'section-6.webp',
            alt: '학부모앱 배경지식 설정 안내',
        },
        {
            top: 6459,
            left: 0,
            width: 1260,
            height: 500,
            file: 'section-7.webp',
            alt: '좋은 콘텐츠를, 우리 아이에게 필요한 만큼',
        },
    ],
    sections: [
        {
            key: 'contents_0',
            top: 0,
            height: 810,
        },
        {
            key: 'slogan',
            top: 810,
            height: 318,
        },
        {
            key: 'contents_1',
            top: 1128,
            height: 655,
        },
        {
            key: 'contents_2',
            top: 1783,
            height: 880,
        },
        {
            key: 'contents_3',
            top: 2666,
            height: 1147,
        },
        {
            key: 'contents_4',
            top: 3813,
            height: 823,
        },
        {
            key: 'contents_5',
            top: 4636,
            height: 1136,
        },
        {
            key: 'contents_6',
            top: 5772,
            height: 687,
        },
        {
            key: 'contents_7',
            top: 6459,
            height: 500,
        },
    ],
    texts: [
        {
            key: '2019:2282',
            tag: 'p',
            left: 64,
            top: 271,
            width: 70,
            height: 28,
            lineHeight: 28,
            runs: [
                {
                    text: '배경지식',
                    left: 0.43,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 20,
            weight: 700,
            color: 'white',
        },
        {
            key: '2019:2284',
            tag: 'h1',
            left: 47,
            top: 319.5,
            width: 1179,
            height: 225,
            lineHeight: 75,
            runs: [
                {
                    text: '공부만큼 중요한 ',
                    left: 0,
                    top: 0,
                },
                {
                    text: '세상을 ',
                    left: 0,
                    top: 75,
                },
                {
                    text: '아는 힘',
                    left: 171.562,
                    top: 75,
                },
                {
                    text: ', ',
                    left: 343.12,
                    top: 75,
                },
                {
                    text: '윙크라 가능합니다',
                    left: 0,
                    top: 150,
                },
            ],
            font: 'Paperlogy',
            size: 60,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2297',
            tag: 'p',
            left: 316,
            top: 875.0001,
            width: 629,
            height: 39,
            lineHeight: 39,
            runs: [
                {
                    text: '아이가 좋아한다고 아무 콘텐츠나 보여줄 수는 없겠죠?',
                    left: 0.159,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 600,
            color: 'white',
        },
        {
            key: '2019:2298',
            tag: 'h2',
            left: 241,
            top: 925,
            width: 792,
            height: 130,
            lineHeight: 65,
            runs: [
                {
                    text: '스마트기기를 완전히 피하기 어려운 시대',
                    left: 0.077,
                    top: 0,
                },
                {
                    text: '중요한 것은',
                    left: 51.518,
                    top: 65,
                },
                {
                    text: ' ‘무엇을 보느냐’ ',
                    color: '#FFF345',
                    left: 282.47,
                    top: 65,
                },
                {
                    text: '입니다',
                    left: 608.5,
                    top: 65,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2291',
            tag: 'h3',
            left: 292,
            top: 1595,
            width: 225,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '재미로만 접하는 콘텐츠',
                    left: 3.422,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:2293',
            tag: 'h3',
            left: 756,
            top: 1596,
            width: 206,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '윙크 배경지식',
                    left: 0.29,
                    top: 0,
                },
                {
                    text: '이라면?',
                    left: 130.11,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2290',
            tag: 'p',
            left: 275,
            top: 1638,
            width: 260,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '재미있는 순간은 많지만',
                    left: 47.822,
                    top: 0,
                },
                {
                    text: ' 아이의 관심이 한쪽에 머물 수 있어요',
                    left: 0.142,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2292',
            tag: 'p',
            left: 715,
            top: 1638,
            width: 287,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '콘텐츠를 보는 동안 다양한 세상을 만나며',
                    left: 0.28,
                    top: 0,
                },
                {
                    text: ' 관심이 자연스럽게 지식으로 확장됩니다',
                    left: 2.48,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2310',
            tag: 'h2',
            left: 316,
            top: 1876,
            width: 649,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '세상의 다양한 지식을 담았습니다',
                    left: 0.062,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2306',
            tag: 'p',
            left: 600,
            top: 2038,
            width: 60,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '예술',
                    left: 0.08,
                    top: 0,
                },
                {
                    text: '경험',
                    left: 0.08,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2305',
            tag: 'p',
            left: 392,
            top: 2096,
            width: 60,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '자연',
                    left: 0.08,
                    top: 0,
                },
                {
                    text: '탐구',
                    left: 0.08,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2307',
            tag: 'p',
            left: 784,
            top: 2096,
            width: 130,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '신체운동,',
                    left: 0.22,
                    top: 0,
                },
                {
                    text: '건강',
                    left: 35.08,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2304',
            tag: 'p',
            left: 249,
            top: 2221,
            width: 60,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '사회',
                    left: 0.084,
                    top: 0,
                },
                {
                    text: '관계',
                    left: 0.084,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2308',
            tag: 'p',
            left: 964,
            top: 2221,
            width: 60,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '초등',
                    left: 0.08,
                    top: 0,
                },
                {
                    text: '연계',
                    left: 0.08,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2303',
            tag: 'p',
            left: 176,
            top: 2383,
            width: 60,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '의사',
                    left: 0.084,
                    top: 0,
                },
                {
                    text: '소통',
                    left: 0.084,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2309',
            tag: 'p',
            left: 1021,
            top: 2383,
            width: 90,
            height: 86,
            lineHeight: 43,
            runs: [
                {
                    text: '한자',
                    left: 15.08,
                    top: 0,
                },
                {
                    text: '놀이터',
                    left: 0.13,
                    top: 43,
                },
            ],
            shadow: '0 2px 1px rgba(0,0,0,0.25)',
            font: 'Paperlogy',
            size: 34,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2340',
            tag: 'h2',
            left: 337,
            top: 2710,
            width: 566,
            height: 56,
            lineHeight: 56,
            runs: [
                {
                    text: '어린이집, 유치원에서 배우는 내용을',
                    left: 0.031,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2339',
            tag: 'h2',
            left: 421,
            top: 2768,
            width: 398,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '놀면서 익히는 누리n놀이',
                    left: 0.09,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#B126F6',
        },
        {
            key: '2019:2341',
            tag: 'p',
            left: 351,
            top: 2836,
            width: 538,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '누리과정에 맞춘 다양한 콘텐츠',
                    left: 0.32,
                    top: 0,
                    weight: 800,
                },
                {
                    text: '로 아이에게 필요한 경험을 ',
                    left: 286.07,
                    top: 0,
                },
                {
                    text: '재미있게 만나보세요',
                    left: 172.73,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2319',
            tag: 'h3',
            left: 182,
            top: 3223,
            width: 83,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '의사소통',
                    left: 0.016,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:2325',
            tag: 'h3',
            left: 588,
            top: 3223,
            width: 83,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '사회관계',
                    left: 0.02,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:2330',
            tag: 'h3',
            left: 995,
            top: 3223,
            width: 83,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '자연탐구',
                    left: 0.02,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:2318',
            tag: 'p',
            left: 115,
            top: 3260,
            width: 216,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '자신의 생각을 말로 표현하고',
                    left: 8.068,
                    top: 0,
                },
                {
                    text: '바르게 소통하는 방법을 익혀요',
                    left: 0.29,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2324',
            tag: 'p',
            left: 501,
            top: 3260,
            width: 256,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '일상 속 다양한 상황에서 배려하고',
                    left: 10.31,
                    top: 0,
                },
                {
                    text: '다른 사람과 함께 지내는 법을 배워요',
                    left: 0.34,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2329',
            tag: 'p',
            left: 913,
            top: 3260,
            width: 247,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '주변의 자연과 다양한 현상을',
                    left: 23.57,
                    top: 0,
                },
                {
                    text: '관찰하며 호기심과 탐구심을 키워요',
                    left: 0.23,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2332',
            tag: 'h3',
            left: 298,
            top: 3628,
            width: 257,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '예술경험',
                    left: 87.02,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:2335',
            tag: 'h3',
            left: 711,
            top: 3628,
            width: 251,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '신체운동∙건강',
                    left: 59.85,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: '#1D1D1D',
        },
        {
            key: '2019:2333',
            tag: 'p',
            left: 298,
            top: 3667,
            width: 257,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '음악·미술·만들기 등 다양한 활동으로',
                    left: 0.487,
                    top: 0,
                },
                {
                    text: '표현력과 창의력을 길러요',
                    left: 38.544,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2336',
            tag: 'p',
            left: 711,
            top: 3667,
            width: 251,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '몸을 움직이고 바른 생활을 실천하며',
                    left: 0.04,
                    top: 0,
                },
                {
                    text: '건강한 몸과 생활 습관을 만들어요',
                    left: 7.81,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2358',
            tag: 'h2',
            left: 435,
            top: 3884,
            width: 390,
            height: 56,
            lineHeight: 56,
            runs: [
                {
                    text: '학교 공부도, 학교 생활도',
                    left: 0.02,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2360',
            tag: 'h2',
            left: 436,
            top: 3940,
            width: 388,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '미리 만나보는  초등 연계',
                    left: 0.45,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#B126F6',
        },
        {
            key: '2019:2352',
            tag: 'p',
            left: 229,
            top: 4013,
            width: 802,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '처음 만나는 초등학교가 낯설지 않도록,',
                    left: 220.13,
                    top: 0,
                },
                {
                    text: ' 초등 교과의 기초 개념부터 학교생활 규칙까지 ',
                    weight: 800,
                    left: 0.066,
                    top: 34,
                },
                {
                    text: '재미있는 콘텐츠로 자연스럽게 경험해요',
                    left: 431.74,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2355',
            tag: 'h3',
            left: 251,
            top: 4142,
            width: 245,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '초등 교과를 ',
                    left: 0.121,
                    top: 0,
                },
                {
                    text: '미리 친숙하게',
                    color: '#FFF837',
                    left: 114.89,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: 'white',
        },
        {
            key: '2019:2356',
            tag: 'h3',
            left: 764,
            top: 4142,
            width: 245,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '학교 생활도 ',
                    left: 0.12,
                    top: 0,
                },
                {
                    text: '미리 익숙하게',
                    color: '#FFF837',
                    left: 114.89,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 700,
            color: 'white',
        },
        {
            key: '2019:2353',
            tag: 'p',
            left: 202,
            top: 4472,
            width: 343,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '국어·수학·통합교과 등 학교에서 배우게 될 내용을',
                    left: 0.201,
                    top: 0,
                },
                {
                    text: '아이 눈높이의 영상과 놀이로 접해요',
                    left: 46.036,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2354',
            tag: 'p',
            left: 684,
            top: 4472,
            width: 405,
            height: 52,
            lineHeight: 26,
            runs: [
                {
                    text: '급식은 먹는 법, 복도를 다니는 법, 발표는 어떻게 ',
                    left: 32.51,
                    top: 0,
                },
                {
                    text: '하는지 등 학교에서 필요한 생활습관과 규칙을 미리 배워요',
                    left: 0.44,
                    top: 26,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2377',
            tag: 'h2',
            left: 366,
            top: 4703,
            width: 528,
            height: 56,
            lineHeight: 56,
            runs: [
                {
                    text: '우리말 어휘력을 넓히는 한자 학습',
                    left: 0.05,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2376',
            tag: 'h2',
            left: 440,
            top: 4759,
            width: 380,
            height: 52,
            lineHeight: 52,
            runs: [
                {
                    text: '7∙8급 한자도 차근차근!',
                    left: 0,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 40,
            weight: 800,
            color: '#B126F6',
        },
        {
            key: '2019:2378',
            tag: 'p',
            left: 385,
            top: 4826,
            width: 471,
            height: 68,
            lineHeight: 34,
            runs: [
                {
                    text: '초등 문해력의 시작은 풍부한 어휘부터!',
                    left: 54.95,
                    top: 0,
                    weight: 800,
                },
                {
                    text: '낱말의 뜻을 이해하는 힘도 윙크와 함께 키워보세요',
                    left: 0.13,
                    top: 34,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2366',
            tag: 'h3',
            left: 123,
            top: 5217,
            width: 198,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '영상으로 먼저 만나고',
                    left: 0.293,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2368',
            tag: 'h3',
            left: 531,
            top: 5217,
            width: 198,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '오늘의 한자를 배우고',
                    left: 0.29,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2370',
            tag: 'h3',
            left: 939,
            top: 5217,
            width: 198,
            height: 32,
            lineHeight: 32,
            runs: [
                {
                    text: '직접 따라쓰며 익혀요',
                    left: 0.29,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2365',
            tag: 'p',
            left: 87,
            top: 5256,
            width: 271,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '재미있는 영상을 보며',
                    left: 61.101,
                    top: 0,
                },
                {
                    text: ' 한자의 뜻과 쓰임을 자연스럽게 접해요',
                    left: 0.061,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2367',
            tag: 'p',
            left: 500,
            top: 5256,
            width: 260,
            height: 27,
            lineHeight: 27,
            runs: [
                {
                    text: '한자의 모양과 뜻, 유래를 함께 배워요',
                    left: 0.03,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2369',
            tag: 'p',
            left: 944,
            top: 5256,
            width: 189,
            height: 54,
            lineHeight: 27,
            runs: [
                {
                    text: '직접 써보며 획순을 익히고 ',
                    left: 0.15,
                    top: 0,
                },
                {
                    text: '배운 한자를 오래 기억해요',
                    left: 2.35,
                    top: 27,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2375',
            tag: 'p',
            left: 662,
            top: 5415,
            width: 341,
            height: 84,
            lineHeight: 42,
            runs: [
                {
                    text: '학습기에서 배운 한자, ',
                    left: 39.94,
                    top: 0,
                },
                {
                    text: '워크북과 모의고사',
                    color: '#B126F6',
                    left: 0.02,
                    top: 42,
                },
                {
                    text: '로 한번 더!',
                    left: 214.15,
                    top: 42,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2374',
            tag: 'p',
            left: 636,
            top: 5506,
            width: 393,
            height: 58,
            lineHeight: 29,
            runs: [
                {
                    text: '학습한 한자를 ',
                    left: 0.02,
                    top: 0,
                },
                {
                    text: '다시 한번 연습할 수 있는 ',
                    left: 102.15,
                    top: 0,
                },
                {
                    text: '워크북',
                    left: 279.69,
                    weight: 800,
                    top: 0,
                },
                {
                    text: '과 ',
                    left: 326.36,
                    top: 0,
                },
                {
                    text: '실력을',
                    left: 346.31,
                    top: 0,
                },
                {
                    text: '확인해 볼 수 있는 ',
                    left: 45.5,
                    top: 29,
                },
                {
                    text: '모의고사',
                    left: 171.98,
                    weight: 800,
                    top: 29,
                },
                {
                    text: '까지 제공합니다',
                    left: 234.21,
                    top: 29,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2372',
            tag: 'p',
            left: 711.8726,
            top: 5596.6582,
            width: 224,
            height: 31,
            lineHeight: 31,
            runs: [
                {
                    text: '한자 자료 다운로드 받기',
                    left: 0.0074,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2394',
            tag: 'h2',
            left: 445,
            top: 5850,
            width: 386,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '학부모님 활용 ',
                    left: 0.32,
                    top: 0,
                },
                {
                    text: 'Tip!',
                    color: '#096CFF',
                    left: 286.26,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2395',
            tag: 'p',
            left: 409,
            top: 5984,
            width: 452,
            height: 84,
            lineHeight: 42,
            runs: [
                {
                    text: '좋은 콘텐츠도 부모님이 원하는 만큼만!',
                    left: 0.31,
                    top: 0,
                },
                {
                    text: '학부모앱에서 원터치 간편설정',
                    color: '#096CFF',
                    left: 50.76,
                    top: 42,
                },
            ],
            font: 'Pretendard',
            size: 30,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2391',
            tag: 'p',
            left: 630.0273,
            top: 6169,
            width: 156,
            height: 64,
            lineHeight: 32,
            runs: [
                {
                    text: '배경지식 콘텐츠 ',
                    left: 0.0427,
                    top: 0,
                },
                {
                    text: 'ON / OFF',
                    left: 27.7327,
                    top: 32,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2392',
            tag: 'p',
            left: 880.0273,
            top: 6173,
            width: 130,
            height: 34,
            lineHeight: 34,
            runs: [
                {
                    text: '이용시간 설정',
                    left: 0.0927,
                    top: 0,
                },
            ],
            font: 'Pretendard',
            size: 24,
            weight: 800,
            color: '#1D1D1D',
        },
        {
            key: '2019:2393',
            tag: 'p',
            left: 878.0273,
            top: 6221,
            width: 134,
            height: 75,
            lineHeight: 25,
            runs: [
                {
                    text: '아이에게 맞는 ',
                    left: 15.9427,
                    top: 0,
                },
                {
                    text: '콘텐츠 이용시간을 ',
                    left: 0.3827,
                    top: 25,
                },
                {
                    text: '간편하게 설정',
                    left: 18.1327,
                    top: 50,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2390',
            tag: 'p',
            left: 623.0273,
            top: 6246,
            width: 169,
            height: 50,
            lineHeight: 25,
            runs: [
                {
                    text: '필요에 따라 배경지식',
                    left: 10.1027,
                    top: 0,
                },
                {
                    text: '콘텐츠 노출 유무를 설정',
                    left: 0.1327,
                    top: 25,
                },
            ],
            font: 'Pretendard',
            size: 18,
            weight: 500,
            color: '#1D1D1D',
        },
        {
            key: '2019:2401',
            tag: 'h2',
            left: 392,
            top: 6678,
            width: 462,
            height: 70,
            lineHeight: 70,
            runs: [
                {
                    text: '즐겁게 쌓은 배경지식',
                    left: 0.04,
                    top: 0,
                },
                {
                    text: '이',
                    left: 417.96,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: 'white',
        },
        {
            key: '2019:2400',
            tag: 'h2',
            left: 342,
            top: 6747,
            width: 561,
            height: 65,
            lineHeight: 65,
            runs: [
                {
                    text: '세상을 이해하는 힘이 됩니다',
                    left: 0.056,
                    top: 0,
                },
            ],
            font: 'Paperlogy',
            size: 50,
            weight: 800,
            color: '#37C6FF',
        },
    ],
    label: '배경지식',
    frame: '2019:2277',
    heading: '2019:2284',
    link: {
        key: '2019:2372',
        left: 678,
        top: 5583,
        width: 307.043,
        height: 58.3166,
        href: '/reference-room?subject=hanja',
        id: 'subject-choice-download-button',
    },
    animations: [
        {
            file: 'nuri-communication.gif',
            left: 27,
            top: 2961,
            width: 392,
            height: 245,
            alt: '누리놀이 의사소통 학습 화면',
        },
        {
            file: 'nuri-social.gif',
            left: 433,
            top: 2961,
            width: 392,
            height: 245,
            alt: '누리놀이 사회관계 학습 화면',
        },
        {
            file: 'nuri-science.gif',
            left: 840,
            top: 2961,
            width: 392,
            height: 245,
            alt: '누리놀이 자연탐구 학습 화면',
        },
        {
            file: 'nuri-arts.gif',
            left: 230,
            top: 3363,
            width: 392,
            height: 245,
            alt: '누리놀이 예술경험 학습 화면',
        },
        {
            file: 'nuri-health.gif',
            left: 640,
            top: 3363,
            width: 392,
            height: 245,
            alt: '누리놀이 신체운동과 건강 학습 화면',
        },
        {
            file: 'hanja-story.gif',
            left: 26,
            top: 4949,
            width: 392,
            height: 245,
            alt: '한자 뜻과 쓰임을 익히는 영상',
        },
        {
            file: 'hanja-learning.gif',
            left: 434,
            top: 4949,
            width: 392,
            height: 245,
            alt: '한자 모양과 뜻을 배우는 학습 화면',
        },
        {
            file: 'hanja-writing.gif',
            left: 842,
            top: 4949,
            width: 392,
            height: 245,
            alt: '한자 획순과 따라쓰기 학습 화면',
        },
    ],
};
